import { ChangeDetectionStrategy, Component, effect, inject, untracked } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ThemeService } from '../../Shared/Services/theme.service';
import { GlobalLoaderComponent } from '../../Shared/Components/global-loader/global-loader.component';
import { ImpersonationNotchComponent } from '../../Shared/Components/impersonation-notch/impersonation-notch.component';
import { AvUnsupportedDeviceComponent } from '../../Shared/Components/av-unsupported-device/av-unsupported-device.component';
import { DeviceSupportService } from '../../Shared/Services/device-support.service';
import { COMMON_IMPORTS } from '../../Shared/common-imports';
import { ConsentLockDialogComponent } from '../../Shared/Components/consent-lock-dialog/consent-lock-dialog.component';
import { ConsentLockBannerComponent } from '../../Shared/Components/consent-lock-banner/consent-lock-banner.component';
import { ConsentFacade } from '../../../Facades/consent.facade';
import {
  CONSENT_LOCK_DIALOG_BACKDROP_CLASS,
  CONSENT_LOCK_DIALOG_PANEL_CLASS,
  CONSENT_LOCK_DIALOG_WIDTH,
} from '../../../Consts/consent-lock.const';

@Component({
  selector: 'app-root',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ...COMMON_IMPORTS,
    GlobalLoaderComponent,
    ImpersonationNotchComponent,
    AvUnsupportedDeviceComponent,
    ConsentLockBannerComponent,
  ],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class App {
  private readonly themeService = inject(ThemeService);
  private readonly consentFacade = inject(ConsentFacade);
  private readonly dialog = inject(MatDialog);
  private lockDialogRef: MatDialogRef<ConsentLockDialogComponent> | null = null;

  readonly blocked = inject(DeviceSupportService).blocked;

  readonly shouldLock = this.consentFacade.shouldLock;

  constructor() {
    effect(() => {
      const lock = this.shouldLock();

      untracked(() => (lock ? this.openLockDialog() : this.closeLockDialog()));
    });
  }

  private openLockDialog(): void {
    if (this.lockDialogRef) {
      return;
    }

    this.lockDialogRef = this.dialog.open(ConsentLockDialogComponent, {
      width: CONSENT_LOCK_DIALOG_WIDTH,
      maxWidth: '95vw',
      panelClass: CONSENT_LOCK_DIALOG_PANEL_CLASS,
      backdropClass: CONSENT_LOCK_DIALOG_BACKDROP_CLASS,
      disableClose: true,
      closeOnNavigation: false,
      autoFocus: 'dialog',
    });
  }

  private closeLockDialog(): void {
    this.lockDialogRef?.close();
    this.lockDialogRef = null;
  }
}
